import { h, Component } from 'preact';
import Theaters from 'components/shared/theaters/theaters';
// import Store from 'store/store';
// import * as actions from 'store/actions';
import Cities from 'components/pages/showtimes/cities';
import Filters from 'components/pages/showtimes/filters';
import pure from 'utils/pure';
import LocationSearch from 'components/pages/showtimes/locationSearch';
import Carousel from 'components/shared/carousel/carousel';
import { smoothScrollTo } from 'utils/smoothScroll';
import { accessNested, condClass, joinClasses } from 'utils/utils';
import { SvgFatArrowRight } from 'components/shared/svgIcons/svgIcons.js';
import s from 'components/pages/showtimes/selection.sss';
import { Link } from 'components/core/link/link.js';
import HTML from 'components/core/html/html';

// TODO: util
// Color functions to get logo shade based on text color
let RGBcache = {};
// Parses color string in simple format (rgb() )
function simpleColor(str) {
	if (!str || typeof str !== 'string') {
		return null;
	}
	let match;
	match = str.match(/^rgba?\(([0-9]+)\s*,\s*([0-9]+)\s*,\s*([0-9]+)/i);
	if (match) {
		let res = { r: +match[1], g: +match[2], b: +match[3] };
		return RGBcache[str] = res;
	}
	match = str.match(/^#([0-9a-f]{2})([0-9a-f]{2})([0-9a-f]{2})$/i);
	if (match) {
		let res = { r: parseInt(match[1], 16), g: parseInt(match[2], 16), b: parseInt(match[3], 16) };
		return RGBcache[str] = res;
	}
	match = str.match(/^#([0-9a-f])([0-9a-f])([0-9a-f])$/i);
	if (match) {
		let res = {
			r: parseInt(match[1] + match[1], 16),
			g: parseInt(match[2] + match[2], 16),
			b: parseInt(match[3] + match[3], 16)
		};
		return RGBcache[str] = res;
	}
	return null;
}
// Get the rgb values from a CSS color
// eg 'salmon' -> { r: 250, g: 128, b: 114 }
function cssColor(str) {
	if (!str || typeof str !== 'string') {
		return { r: 0, g: 0, b: 0 };
	}
	if (RGBcache[str]) return RGBcache[str];
	let basicResult = simpleColor(str);
	if (basicResult) {
		return RGBcache[str] = basicResult;
	}
	if (typeof document === 'undefined') {
		return RGBcache[str] = { r: 0, g: 0, b: 0 };
	}
	// Not a standard thing. Could be a color name or hsl. Let's just use an actual element to figure it out
	let tester = document.createElement('div');
	tester.style.color = str;
	document.body.appendChild(tester);
	let style = getComputedStyle(tester);
	let result = style.color;
	document.body.removeChild(tester);
	return RGBcache[str] = (simpleColor(result) || { r: 0, g: 0, b: 0 });
}

export default @pure class Selection extends Component {
	/**
	 * LifeCycle
	**/
	constructor() {
		super();
		this.isAtTop = undefined;

		this.state.activeTheater = null;
		this.$activeTheater = null;
	}

	componentDidMount() {
		window.addEventListener('scroll', this.handleScroll, true);
	}

	componentWillReceiveProps({ client }) {
		// Should we filter with something else?
		// Scroll back up when the city changes...
		let oldClient = this.props.client;
		let cityChanged = oldClient.geo && client.geo.city !== oldClient.geo.city;
		if (cityChanged) {
			this.handleTop();
		}
	}

	/**
	 * Event Handlers
	**/

	handleScroll = () => {
		if (!this.$theaters || !this.$theaters.base) {
			return;
		}
		let theatersTop = this.$theaters.base.offsetTop;

		// const scrollPos = (document.documentElement && document.documentElement.scrollTop) || document.body.scrollTop);
		const scrollPos = Math.max(window.pageYOffset, document.documentElement.scrollTop, document.body.scrollTop);

		const isAtTop = scrollPos <= theatersTop;

		if (isAtTop === this.isAtTop) {
			return;
		}
		this.isAtTop = isAtTop;
		if (this.$toTop) {
			this.$toTop.style.opacity = isAtTop ? 0 : 1;
			this.$toTop.style.visibility = isAtTop ? 'hidden' : 'visible';
		}
	}

	handleTop = () => {
		// Killian / this isn't ideal but there is a bug with the smoothscroll.js and safari
		// I'm just removing the glitchy scroll until we have a more comprehensive solution
		let isSafari = !['isChrome', 'isEdge', 'isIE', 'isFirefox', 'isIOS'].find(e => this.props.client[e]);
		let scrollTime = isSafari ? 0 : 500;
		smoothScrollTo('root', 0, scrollTime, { force: true });
	}

	/**
	 * Render
	 */

	getTopContent() {
		// Oops there was already selectionHeaderImage doing this. Oh well
		let image = accessNested(this.props, 'pageData.top.image');
		let text = accessNested(this.props, 'pageData.top.text');
		let textLink = accessNested(this.props, 'pageData.top.textLink');
		if (!text && !image) return;
		if (image) {
			if (image.indexOf('//') === -1) {
				image = this.props.appData.urls.roots.image + '/' + image;
			}
			image = <img key="top-image" src={image} alt="top image" class={s.topImage} />;
			let imageLink = accessNested(this.props, 'pageData.top.imageLink');
			if (imageLink) {
				let imageTrackId = accessNested(this.props, 'pageData.top.imageTrackId');
				image = (
					<Link
						key="top-image-link"
						trackId={imageTrackId}
						linkClass={s.topImageLink}
						href={imageLink}
						target="_blank"
					>
						{image}
					</Link>
				);
			}
		}
		if (text) {
			text = <HTML key="top-text" class={s.topText} content={text.replace('\n', '<br>')} markdown />;
		}

		if (textLink) {
			text = (
				<Link
					key="top-text-link"
					linkClass={s.textLink}
					href={textLink.page ? undefined : textLink.path}
					pageId={textLink.page}
					target={textLink.page ? undefined : '_blank'}
				>
					{text}
				</Link>
			);
		}
		return accessNested(this.props, 'pageData.top.imageAfterText', false) ? [text, image] : [image, text];
	}

	renderSeeTheaters() {
		const data = this.props.pageData;
		if (data.seeTheaters && data.seeTheaters.url) {
			return (
				<Link
					linkClass={s.seeTheatersLink}
					href={data.seeTheaters.url}
					pageId={data.seeTheaters.page}
				>
					{data.seeTheaters.text || 'See Theaters'}
				</Link>
			);
		}
	}

	getExtraContent() { }

	getBottomContent() { }

	checkSelectionHeaderImage() {
		const imgURL = this.props.pageData.selectionHeaderImage;
		const carouselData = this.props.pageData.carousel;
		if (carouselData) {
			const carouselRoot = this.props.appData.urls.roots.imageRegion + '/carousel';
			const transition = carouselData.transition;
			const slides = carouselData.items;
			const slideDuration = carouselData.slideDuration;
			const slideDelay = carouselData.slideDelay;
			const progressIcons = carouselData.showProgressIcons;

			let extraProps = {};
			if (carouselData.fixedMode) {
				extraProps.customShowInactive = true;
				extraProps.slideClass = ({ index }) => {
					if (!this.slidesShown && index > 0) this.slidesShown = true;
					this.slidesState = !this.slidesState;
					return joinClasses(s.carouselSlides, this.slidesState && s.slideOdd, this.slidesShown && s.slidesShown);
				};
				extraProps.slideStyle = ({ index, duration }) => {
					let style = { transform: 'translateX(-' + 100 * index + '%)' };
					if (carouselData.slideAnimation) {
						// slide to the left/right
						// remove the animation in charge of the fade-out/fade-in
						style.animation = 'none';
					} else {
						// fade-out / fade-in
						//   the animation is in charge of the opacity
						//   then we transition the position instantly when both slides are completely hidden
						style.transitionDuration = '0s';
						style.transitionDelay = duration * 0.5 + 'ms';
					}
					return style;
				};
			}
			return (
				<Carousel
					mediaRoot={carouselRoot}
					slides={slides}
					transition={transition}
					slideDuration={slideDuration}
					slideDelay={slideDelay}
					showProgressIcons={progressIcons}
					autoSlide
					appData={this.props.appData}
					showtimes={this.props.showtimes}
					{...extraProps}
				/>
			);
		}
		if (imgURL) {
			return <img class={s.selectionHeaderImage} src={imgURL} />;
		}
	}

	renderBanner() {
		let props = this.props;
		let theaters = props.showtimes.theaters;
		if (!theaters || !theaters.length) {
			return;
		}

		let country = accessNested(props, 'client.geo.countryCode');
		let studio = accessNested(props, 'appData.meta.studio.slug');
		let sharedImages = accessNested(props, 'appData.urls.roots.sharedImages') || '';

		let shade = accessNested(props, 'appData.styling.dataProviderLogoShade');
		if (!shade) {
			// Use a color based on Styling > base-textColor
			let textColor = cssColor(accessNested(props, 'appData.styling.variables.base-textColor'));
			// Values based on https://stackoverflow.com/a/3943023/1336843
			let lightness = textColor.r * 0.299 + textColor.g * 0.587 + textColor.b * 0.114;
			shade = lightness > 186 ? 'dark' : 'light';
		}
		let dataProvRoot = sharedImages + '/data_providers/' + shade;

		// [2019-09-19: we don't deal with eBroadcast anymore]
		// let isEbroadcast = theaters.find(t => t.providerId === 'ebroadcast');
		let isCineman = studio !== 'universalstudios' && (country === 'ch' || country === 'ch_fr');

		if (isCineman) {
			let copy = accessNested(props, 'appData.copy.$CINEMAN_SHOWTIMES');
			return (
				<div class={joinClasses(s.banner, s.cineman)}>
					<img
						src={dataProvRoot + '/cineman.png'}
						alt="Cineman Logo"
						class={s.logo}
					/>
					<span class={s.text}>{copy}</span>
				</div>
			);
		}
	}

	render({ appData, showtimes, client, activePage, pageData, header }) {
		let { copy } = appData;
		let {
			theaters = [],
			filters,
			cities,
			cityShowCount
		} = showtimes || {};

		let banner = this.renderBanner();

		let toTopClass = s.toTop;
		if (this.props.fullScreen) {
			toTopClass = s.toTopFullScreen;
		}
		toTopClass += condClass(client.deviceSize === 'mobile', s.hidden);
		toTopClass += condClass(header && header.sideNavActive, s.noHeader);

		let backButton = (
			<div
				class={toTopClass}
				onClick={this.handleTop}
				ref={toTop => {
					this.$toTop = toTop;
				}}
			>
				<span />
				<SvgFatArrowRight class={s.svgWrapper} />
				{copy.$BACK_TO_SEARCH_AND_FILTER}
			</div>
		);

		let totalScreeningsCount = 0;
		let filteredScreeningsCount = 0;

		theaters.forEach(theater => {
			totalScreeningsCount += theater.activeScreenings.length;
			filteredScreeningsCount += theater.filteredScreenings.length;
		});

		const selectionHeaderImage = this.checkSelectionHeaderImage();

		const filteredTheaters = theaters
			? theaters.filter(t => t.enabled && (showtimes.showHiddenExhibitors || t.activeExhibitor))
			: [];
		const filtersHidden = !filteredTheaters.length;

		let citiesEl;
		let showCities = !pageData.hideNearCities && !accessNested(appData, 'options.hideNearCities');
		if (showCities) {
			const radiusFactor = accessNested(appData, 'pages.showtimes.data.radiusFactor', 1);
			let moreLinkOut = accessNested(appData, 'options.moreCitiesLinkOutForIframeMode') && client.iframe;
			citiesEl = (
				<Cities
					cities={cities}
					loading={showtimes.loading}
					copy={appData.copy}
					clientGeo={client.geo}
					cityShowCount={cityShowCount}
					searchRadius={radiusFactor}
					moreLinkOut={moreLinkOut}
					showState={accessNested(appData, 'options.showNearCitiesState')}
				/>
			);
		}

		let noTheaters = !theaters || !theaters.length;
		let hideFilterCta = noTheaters && (!showtimes.error || showtimes.error === 'BOUNDING_REGION');

		let zipcodesOnly = accessNested(pageData, 'postcodesOnly');

		return (
			<div class={joinClasses(s.container, pageData.embedMode && s.containerEmbed, this.props.class)}>
				<div class={s.header} key="header">
					{selectionHeaderImage}
				</div>
				{this.getTopContent()}
				{this.renderSeeTheaters()}
				<LocationSearch
					key="locationSearch"
					clientGeo={client.geo}
					filters={filters}
					class={s.location}
					copy={copy}
					appData={appData}
					ariaLabel={pageData && pageData.searchInputAriaLabel}
				/>
				<HTML
					class={joinClasses(s.filterCta, hideFilterCta && s.hidden)}
					content={zipcodesOnly ? copy.$FILTER_CTA_ZIPCODES : copy.$FILTER_CTA}
					markdown
				/>
				{backButton}
				<Filters
					filters={filters}
					totalScreeningsCount={totalScreeningsCount}
					filteredScreeningsCount={filteredScreeningsCount}
					device={client.device}
					hidden={filtersHidden}
					ref={filters => this.$filters = filters}
					noText={pageData.hideFilteredTheaters || pageData.noFilterText}
					copy={copy}
					pageData={pageData}
				/>
				{banner}
				<Theaters
					copy={copy}
					loading={showtimes.loading}
					client={client}
					theaters={theaters}
					selectedDate={showtimes.selectedDate}
					selectedProvider={showtimes.provider}
					appData={appData}
					filters={filters}
					showtimesErr={showtimes.error}
					ticketing={showtimes.ticketing}
					ref={theaters => this.$theaters = theaters}
					activePage={activePage}
					pageData={pageData}
					showHiddenExhibitors={showtimes.showHiddenExhibitors}
					showtimes={showtimes}
					addressClickOpensMap
					preventScrollToTheater={this.props.preventScrollToTheater}
				/>
				{this.getExtraContent()}
				{!pageData.hideSuggestedCities && citiesEl}
				{this.getBottomContent()}
			</div>
		);
	}
}
